import { useState } from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import type { Matcher } from "react-day-picker";

import { WFPButton } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

interface DatePickerProps {
  id?: string;
  value: Date | null;
  onChange: (value: Date | null) => void;
  placeholder: string;
  disabled?: Matcher | Matcher[];
  invalid?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export const DatePicker = ({
  id,
  value,
  onChange,
  placeholder,
  disabled,
  invalid,
  isDisabled,
  className,
}: DatePickerProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <WFPButton
          type="button"
          variant="outline"
          id={id}
          disabled={isDisabled}
          aria-invalid={invalid}
          className={cn(
            "w-full justify-start font-normal",
            !value && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="size-4" />
          {value ? format(value, "d MMM yyyy") : placeholder}
        </WFPButton>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value ?? undefined}
          onSelect={selected => {
            onChange(selected ?? null);
            setOpen(false);
          }}
          disabled={disabled}
        />
      </PopoverContent>
    </Popover>
  );
};
